import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import AuditTrailConnected from 'pages/views/settings/AuditTrail';

const paths = {
  auditTrail: '/settings/audit-trail',
};

export default [
  <RouteIfRights
    exact
    path={paths.auditTrail}
    key={paths.auditTrail}
    component={AuditTrailConnected}
    rights="admin"
  />,
];

export { paths };
